import axios from "axios";
import { baseUrl, portal } from "../App";
import { EVENT_ID } from "../assets/constant";
import { transformDailyWinnerNDataArray, transformLeaderboardDataArrayMemory, transformMemoryMatchWinnerLeaderboardDataArray, transformQuizardWinnerLeaderboardDataArray, transformWinnerlistDataArray } from "./transformDataFormat";
import { memoryMatchDummyData, spellingBeeDummyData, wordlyDummyData } from "./dummyData";



export const fetchLeaderboardByLeaderboarName = async (leaderboardName) => {
  if(!leaderboardName) return [];
  // for daily leaderboard
  if(leaderboardName === 'leaderboard_wordly_bangla'){
    const res = await axios.get(`${baseUrl}/api/leaderboard/?portal=${portal}&event_id=${EVENT_ID.WORDLY_BANGLA_EVENT}`);
    if(res.data.length === 0) return wordlyDummyData;
    return res.data;
  }else if(leaderboardName === 'leaderboard_wordly_english'){
    const res = await axios.get(`${baseUrl}/api/leaderboard/?portal=${portal}&event_id=${EVENT_ID.WORDLY_ENGLISH_EVENT}`);
    if(res.data.length === 0) return wordlyDummyData;
    return res.data;
  }else if(leaderboardName === 'leaderboard_spelling'){
    const res = await axios.get(`${baseUrl}/api/leaderboard/?portal=${portal}&event_id=${EVENT_ID.SPELLING_BEE_EVENT}`);
    if(res.data.length === 0) return spellingBeeDummyData;
    return res.data;
  }else if(leaderboardName === 'leaderboard_memory_e'){
    const res = await axios.get(`${baseUrl}/api/leaderboard/memorymatch/?portal=${portal}&event_id=${EVENT_ID.MEMORY_MATCH_EVENT}&difficulty=easy`);
    if(res.data.length === 0) return transformLeaderboardDataArrayMemory(memoryMatchDummyData);
    return transformLeaderboardDataArrayMemory(res.data);
  }else if(leaderboardName === 'leaderboard_memory_m'){
    const res = await axios.get(`${baseUrl}/api/leaderboard/memorymatch/?portal=${portal}&event_id=${EVENT_ID.MEMORY_MATCH_EVENT}&difficulty=medium`);
    if(res.data.length === 0) return transformLeaderboardDataArrayMemory(memoryMatchDummyData);
    return transformLeaderboardDataArrayMemory(res.data);
  }else if(leaderboardName === 'leaderboard_memory_h'){
    const res = await axios.get(`${baseUrl}/api/leaderboard/memorymatch/?portal=${portal}&event_id=${EVENT_ID.MEMORY_MATCH_EVENT}&difficulty=hard`);
    if(res.data.length === 0) return transformLeaderboardDataArrayMemory(memoryMatchDummyData);
    return transformLeaderboardDataArrayMemory(res.data);
  }
  else if(leaderboardName === 'winner_y_spelling'){
    const res = await axios.get(`${baseUrl}/money/dailyWinnerNData/?event_id=${EVENT_ID.SPELLING_BEE_EVENT}`);
    return transformDailyWinnerNDataArray(res.data,30);
  }
  else if(leaderboardName === 'winner_y_wordly'){
    const res = await axios.get(`${baseUrl}/money/dailyWinnerNData/?event_id=${EVENT_ID.WORDLY_ENGLISH_EVENT}`);
    return transformDailyWinnerNDataArray(res.data,30);
  }
  else if(leaderboardName ==='winner_y_memory_easy'){
    const res = await axios.get(`${baseUrl}/money/memoryMatchWinnerYesterday/?difficulty=easy`);
    return transformMemoryMatchWinnerLeaderboardDataArray(res.data?.easy||[],10);
  }
  else if(leaderboardName ==='winner_y_memory_medium'){
    const res = await axios.get(`${baseUrl}/money/memoryMatchWinnerYesterday/?difficulty=medium`);
    return transformMemoryMatchWinnerLeaderboardDataArray(res.data?.medium||[],10);
  }
  else if(leaderboardName ==='winner_y_memory_hard'){
    const res = await axios.get(`${baseUrl}/money/memoryMatchWinnerYesterday/?difficulty=hard`);
    return transformMemoryMatchWinnerLeaderboardDataArray(res.data?.hard||[],10);
  }
  // for last 7 days winner list

  else if(leaderboardName === 'winner_wordly'){
    const res = await axios.get(`${baseUrl}/money/wordlyWeeklyNWinner/?numberOfWinner=10`);
    return transformWinnerlistDataArray(res.data,10);
  }
  else if(leaderboardName === 'winner_spelling'){
    const res = await axios.get(`${baseUrl}/money/weeklyWinner/?event_id=${EVENT_ID.SPELLING_BEE_EVENT}&numberOfWinner=10`);
    return transformWinnerlistDataArray(res.data,10);
  }
  else if(leaderboardName === 'winner_memory_easy'){
    // https://api.bl.quizard.live/money/memoryMatchWeeklyWinner/
    const res = await axios.get(`${baseUrl}/money/memoryMatchWeeklyWinner/`);
    return transformMemoryMatchWinnerLeaderboardDataArray(res.data?.easy||[],5,'easy');
  }
  else if(leaderboardName === 'winner_memory_medium'){
    const res = await axios.get(`${baseUrl}/money/memoryMatchWeeklyWinner/`);
    return transformMemoryMatchWinnerLeaderboardDataArray(res.data?.medium||[],5,'medium');
  }
  else if(leaderboardName === 'winner_memory_hard'){
    const res = await axios.get(`${baseUrl}/money/memoryMatchWeeklyWinner/`);
    return transformMemoryMatchWinnerLeaderboardDataArray(res.data?.hard||[],5,'hard');
  }


  else{
    return [];
  }
}